import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

const ChipPrefix = "AutocompleteAuthorsChip";

export const chipClasses = {
  root: `${ChipPrefix}-root`,
};

export const AutocompleteAuthorsChip = styled(Chip)(({ theme }) => ({
  [`&.${chipClasses.root}`]: {
    marginTop: 1,
    marginBottom: 0,
    marginRight: 2,
    "& .MuiChip-label": {
      color: theme.palette.primary.dark,
    },
    "& .MuiChip-deleteIcon": {
      color: theme.palette.primary.dark,
    },
  },
}));
